__turbopack_context__.v({
  "simple-entries": "simple-entries-module-scss-module__HA58xq__simple-entries",
  "simple-entries__content": "simple-entries-module-scss-module__HA58xq__simple-entries__content",
  "simple-entries__content--open": "simple-entries-module-scss-module__HA58xq__simple-entries__content--open",
  "simple-entries__entry-content": "simple-entries-module-scss-module__HA58xq__simple-entries__entry-content",
  "simple-entries__entry-content--active": "simple-entries-module-scss-module__HA58xq__simple-entries__entry-content--active",
  "simple-entries__icon": "simple-entries-module-scss-module__HA58xq__simple-entries__icon",
  "simple-entries__icon--active": "simple-entries-module-scss-module__HA58xq__simple-entries__icon--active",
  "simple-entries__item": "simple-entries-module-scss-module__HA58xq__simple-entries__item",
  "simple-entries__toggle": "simple-entries-module-scss-module__HA58xq__simple-entries__toggle",
});
